import React from 'react';
import { ExternalLink } from '../../components';
import { FormattedMessage } from '../../util/reactIntl';

function PrivacyGreek() {
  return (
    <div className="privacy-page">
      {/* Intro */}
      <h1>ΠΟΛΙΤΙΚΗ ΑΠΟΡΡΗΤΟΥ</h1>
      <p>
        Η παρούσα Πολιτική Απορρήτου σχετικά με την επεξεργασία δεδομένων προσωπικού χαρακτήρα από
        τη «VivianLab» έχει ως στόχο να σας βοηθήσει να κατανοήσετε ποια προσωπικά δεδομένα
        συλλέγουμε, γιατί τα συλλέγουμε και τι κάνουμε με αυτά. Παρακαλούμε αφιερώστε λίγο χρόνο για
        να διαβάσετε προσεκτικά την παρούσα Πολιτική Απορρήτου. Θέλουμε να είστε απολύτως ξεκάθαροι
        σχετικά με τον τρόπο που χρησιμοποιούμε τις πληροφορίες σας και τους τρόπους με τους οποίους
        μπορείτε να ασκήσετε τα δικαιώματά σας. Η παρούσα Πολιτική Απορρήτου αντικατοπτρίζει επίσης τις
        υποχρεώσεις μας βάσει της Πράξης της ΕΕ για την Τεχνητή Νοημοσύνη (EU AI Act) σχετικά με τη
        διαφάνεια, τη λογοδοσία και την υπεύθυνη χρήση των συστημάτων ΤΝ.
      </p>
      <p>
        <strong>Εδαφικό Πεδίο Εφαρμογής.</strong> Η παρούσα Πολιτική Απορρήτου έχει σχεδιαστεί για να
        συμμορφώνεται με τον Γενικό Κανονισμό Προστασίας Δεδομένων (GDPR) και τους ισχύοντες νόμους
        περί προστασίας δεδομένων στην Ελλάδα και τον Ευρωπαϊκό Οικονομικό Χώρο (ΕΟΧ). Η Πλατφόρμα και
        οι Υπηρεσίες μας προορίζονται κυρίως για χρήστες που βρίσκονται εντός του ΕΟΧ. Εάν επιλέξετε να
        αποκτήσετε πρόσβαση ή να χρησιμοποιήσετε την Πλατφόρμα από χώρα εκτός του ΕΟΧ, το πράττετε με
        δική σας πρωτοβουλία και είστε αποκλειστικά υπεύθυνοι για τη διασφάλιση ότι η εν λόγω πρόσβαση
        και χρήση συμμορφώνεται με τους νόμους της χώρας διαμονής σας. Όπου απαιτείται, λαμβάνουμε επίσης
        υπόψη την ισχύουσα νομοθεσία εκτός ΕΟΧ, συμπεριλαμβανομένων των νόμων περί ιδιωτικότητας των
        Ηνωμένων Πολιτειών, όπως ο Νόμος περί Προστασίας Προσωπικών Δεδομένων των Καταναλωτών της
        Καλιφόρνια (CCPA/CPRA) και άλλοι κανονισμοί σε επίπεδο πολιτειών. Εάν αποκτάτε πρόσβαση ή
        χρησιμοποιείτε την Πλατφόρμα εκτός του ΕΟΧ, αναγνωρίζετε ότι τα προσωπικά σας δεδομένα
        ενδέχεται να υποβληθούν σε επεξεργασία σύμφωνα με τα πρότυπα της ΕΕ, συμπληρούμενα από
        πρόσθετες εγγυήσεις όπου απαιτείται από την ισχύουσα τοπική νομοθεσία.
      </p>
      <p>
        Η παρούσα Πολιτική Απορρήτου εφαρμόζεται στα προσωπικά σας δεδομένα όταν επισκέπτεστε και
        χρησιμοποιείτε την διαδικτυακή μας Πλατφόρμα – www.vivianlab.com («Πλατφόρμα»/«η
        Πλατφόρμα»), όταν χρησιμοποιείτε τις υπηρεσίες μας που είναι διαθέσιμες σε αυτήν, και/ή όταν
        χρησιμοποιείτε τις κινητές/τεχνολογικές μας εφαρμογές (Apps). Δεν εφαρμόζεται σε άλλες
        εφαρμογές/ιστότοπους/ηλεκτρονικά καταστήματα και/ή υπηρεσίες που δεν ανήκουν ή δεν
        ελέγχονται από εμάς.
      </p>
      <p>
        Όταν χρησιμοποιείτε τις υπηρεσίες μας που είναι διαθέσιμες στην Πλατφόρμα, αποδέχεστε ότι
        έχετε διαβάσει και κατανοήσει την παρούσα Πολιτική Απορρήτου σχετικά με την επεξεργασία
        δεδομένων προσωπικού χαρακτήρα από τη «VivianLab».
      </p>

      <h3>Εδαφικό πεδίο εφαρμογής / Ευθύνη χρήστη</h3>
      <p>
        Η παρούσα Πολιτική Απορρήτου έχει καταρτισθεί σύμφωνα με τον Γενικό Κανονισμό για την
        Προστασία Δεδομένων (GDPR) και την εφαρμοστέα νομοθεσία περί προστασίας δεδομένων στην
        Ελλάδα και τον Ευρωπαϊκό Οικονομικό Χώρο (ΕΟΧ). Οι υπηρεσίες μας και οι μηχανισμοί
        συμμόρφωσης έχουν σχεδιαστεί αποκλειστικά με βάση το ευρωπαϊκό νομικό πλαίσιο.
      </p>
      <p>
        Εάν αποκτάτε πρόσβαση στην Πλατφόρμα από χώρα εκτός ΕΟΧ, αναγνωρίζετε και αποδέχεστε ότι:
      </p>
      <ul>
        <li>η χρήση της Πλατφόρμας γίνεται με δική σας ευθύνη,</li>
        <li>
          η Εταιρεία συμμορφώνεται μόνο με το ευρωπαϊκό νομικό πλαίσιο και όχι με τη νομοθεσία
          τρίτων χωρών, και
        </li>
        <li>
          ενδέχεται να μην παρέχουμε το ίδιο επίπεδο συμμόρφωσης ή δικαιωμάτων που προβλέπονται από
          τη νομοθεσία της χώρας εκτός ΕΟΧ.
        </li>
      </ul>
      <p>
        Εφόσον η τοπική νομοθεσία της χώρας σας επιβάλλει αυστηρότερες ή διαφορετικές απαιτήσεις,
        φέρετε την ευθύνη να διασφαλίσετε ότι η χρήση της Πλατφόρμας είναι σύμφωνη με τις τοπικές
        αυτές απαιτήσεις. Σε κάθε περίπτωση, το ευρωπαϊκό δίκαιο υπερισχύει μόνο για την παροχή των
        υπηρεσιών μας εντός του ΕΟΧ.
      </p>

      {/* 1. Ποιοι είμαστε; */}
      <section>
        <h2>1. Ποιοι είμαστε;</h2>
        <p>
          Η εταιρεία που σας παρέχει τις υπηρεσίες μέσω της Πλατφόρμας είναι η VIVIANLAB LTD, με
          καταστατική έδρα και διεύθυνση διοίκησης: 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1,
          VAT BG207933919, email
          info@vivianlab.com (εφεξής καλούμενη «εμείς», «Εταιρεία», «Επιχείρηση»).
        </p>
        <h3>Ο ρόλος μας – Υπεύθυνος Επεξεργασίας και Εκτελών την Επεξεργασία:</h3>
        <p>
          Ανάλογα με την περίπτωση, η «VIVIAN LAB» LTD ενεργεί με διαφορετική ιδιότητα βάσει του
          Γενικού Κανονισμού Προστασίας Δεδομένων (GDPR):
        </p>
        <ul>
          <li>
            Υπεύθυνος Επεξεργασίας είμαστε όταν δημιουργείτε λογαριασμό στην Πλατφόρμα, εγγράφεστε
            στο newsletter μας ή χρησιμοποιείτε τις υπηρεσίες μας για δικούς σας σκοπούς (όπως ο AI
            Assistant). Σε αυτή την περίπτωση καθορίζουμε τους σκοπούς και τα μέσα επεξεργασίας των
            προσωπικών σας δεδομένων.
          </li>
          <li>
            Εκτελών την Επεξεργασία είμαστε όταν χρησιμοποιείτε την Πλατφόρμα για να αλληλεπιδράσετε
            ή να λάβετε υπηρεσίες από τρίτους (π.χ. «Ειδικούς/Specialists»). Σε αυτό το πλαίσιο, ο
            «Specialist» είναι ο Υπεύθυνος Επεξεργασίας των δεδομένων σας και εμείς τα
            επεξεργαζόμαστε για λογαριασμό του και σύμφωνα με τις οδηγίες του, βάσει{' '}
            <ExternalLink href="/data-processing-addendum">
              Σύμβασης Εκτέλεσης Επεξεργασίας (DPA)
            </ExternalLink>{' '}
            που έχει συναφθεί μεταξύ μας και του Specialist.
          </li>
        </ul>

      </section>

      {/* 2. Στοιχεία Επικοινωνίας · 2.1 Ορισμοί */}
      <section>
        <h2>2. Στοιχεία Επικοινωνίας για θέματα Προστασίας Δεδομένων</h2>
        <p>
          Για ερωτήσεις που σχετίζονται με την παρούσα Πολιτική ή με την επεξεργασία των προσωπικών
          σας δεδομένων, μπορείτε να επικοινωνείτε μαζί μας στο info@vivianlab.com ή απευθείας με
          τον Υπεύθυνο Προστασίας Δεδομένων (DPO) μας στο email: experience@vivianlab.com
        </p>
        <p>
          Δεδομένου ότι η προστασία των δεδομένων προσωπικού χαρακτήρα είναι εξαιρετικά σημαντική
          για την Εταιρεία μας, το παρόν έγγραφο καθορίζει τις υποχρεώσεις μας, τον τρόπο χρήσης,
          επικοινωνίας και προστασίας των δεδομένων που λαμβάνουμε, καθώς και τον τρόπο με τον οποίο
          αντιμετωπίζουμε οποιοδήποτε ζήτημα προκύψει μέσω της μεταξύ μας επικοινωνίας.
        </p>

        <h3>2.1 Ορισμοί</h3>
        <ul>
          <li>
            <strong>Νομοθεσία για την Προστασία Δεδομένων:</strong> Κάθε νόμος που αφορά την
            επεξεργασία δεδομένων προσωπικού χαρακτήρα, την ιδιωτικότητα και την ασφάλεια,
            συμπεριλαμβανομένου, ενδεικτικά και όχι περιοριστικά, του Κανονισμού (ΕΕ) 2016/679 «για
            την προστασία των φυσικών προσώπων έναντι της επεξεργασίας δεδομένων προσωπικού
            χαρακτήρα και για την ελεύθερη κυκλοφορία των δεδομένων αυτών και την κατάργηση της
            Οδηγίας 95/46/ΕΚ» (Γενικός Κανονισμός για την Προστασία Δεδομένων – «GDPR»), της Οδηγίας
            2002/58/ΕΚ «σχετικά με την επεξεργασία δεδομένων προσωπικού χαρακτήρα και την προστασία
            της ιδιωτικής ζωής στον τομέα των ηλεκτρονικών επικοινωνιών», όπως αυτή έχει
            ενσωματωθεί, ισχύει και εφαρμόζεται στην ελληνική έννομη τάξη και όπως τροποποιείται από
            καιρού εις καιρό, ή οποιουδήποτε άλλου εφαρμοστέου ή αντικαθιστώντος διεθνούς ή εθνικού
            κανόνα δικαίου σχετικά με την προστασία δεδομένων προσωπικού χαρακτήρα, καθώς και των
            σχετικών κανονισμών, οδηγιών ή κατευθυντήριων γραμμών των αρμόδιων διοικητικών αρχών,
            όπως η Ελληνική Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα.
          </li>
          <li>
            Οι όροι «Υπεύθυνος Επεξεργασίας», «Εκτελών την Επεξεργασία», «Υποκείμενο των Δεδομένων»,
            «Δεδομένα Προσωπικού Χαρακτήρα» και «Επεξεργασία» έχουν την έννοια που τους αποδίδεται
            από τη Νομοθεσία για την Προστασία Δεδομένων.
          </li>
          <li>
            <strong>«Δεδομένα Προσωπικού Χαρακτήρα»:</strong> Κάθε πληροφορία που αφορά
            ταυτοποιημένο ή ταυτοποιήσιμο φυσικό πρόσωπο («Υποκείμενο των Δεδομένων»). Ταυτοποιήσιμο
            φυσικό πρόσωπο είναι εκείνο του οποίου η ταυτότητα μπορεί να εξακριβωθεί, άμεσα ή
            έμμεσα, ιδίως μέσω αναφοράς σε αναγνωριστικό στοιχείο, όπως: ονοματεπώνυμο, διεύθυνση
            email, αριθμός τηλεφώνου, αριθμός ταυτότητας, δεδομένα τοποθεσίας (π.χ. χώρα ή πόλη),
            διαδικτυακό αναγνωριστικό (όπως διεύθυνση IP, αναγνωριστικό cookie), πληροφορίες
            πληρωμών (π.χ. στοιχεία συναλλαγών) ή σε έναν ή περισσότερους παράγοντες που είναι
            χαρακτηριστικοί της σωματικής, φυσιολογικής, γενετικής, ψυχικής, οικονομικής,
            πολιτιστικής ή κοινωνικής ταυτότητας του προσώπου.
          </li>
          <li>
            <strong>«Ειδικές Κατηγορίες Δεδομένων Προσωπικού Χαρακτήρα»</strong> (επίσης γνωστές ως
            «ευαίσθητα δεδομένα») είναι υποσύνολο των Δεδομένων Προσωπικού Χαρακτήρα που
            αποκαλύπτουν πληροφορίες όπως φυλετική ή εθνοτική καταγωγή, πολιτικές απόψεις,
            βιομετρικά δεδομένα (για τον μοναδικό προσδιορισμό προσώπου) και δεδομένα υγείας (όπως
            καταγραφή συμπτωμάτων, στάδιο εμμηνόπαυσης, δεδομένα από φορετές συσκευές/wearables). Τα
            δεδομένα αυτά τα επεξεργαζόμαστε μόνο με τη συμμόρφωση σε αυστηρότερους κανόνες, και
            συνήθως βάσει της ρητής συναίνεσής σας.
          </li>
          <li>
            <strong>«Υπηρεσίες»:</strong> Οι υπηρεσίες που αναφέρονται στην Πλατφόρμα μας και
            προσφέρονται προς χρήση.
          </li>
          <li>
            <strong>«Ιστότοποι»:</strong> Ο ιστότοπος «www.vivianlab.com», που αποτελεί την
            ιστοσελίδα της Εταιρείας μας. Η Εταιρεία διατηρεί ηλεκτρονική Πλατφόρμα που λειτουργεί
            ως διαδικτυακός επαγγελματικός κατάλογος, συνδέοντας τελικούς χρήστες («Χρήστες») με
            επαγγελματίες του χώρου της υγείας («Specialists» / «Ειδικούς»), όπως ιατρούς και
            ειδικούς υγείας, με σκοπό την παροχή συμβουλευτικών υπηρεσιών και υποστήριξης σε θέματα
            υγείας. Επιπλέον, η Πλατφόρμα προσφέρει καινοτόμες ψηφιακές υπηρεσίες,
            συμπεριλαμβανομένου, ενδεικτικά, ενός AI Assistant (AI tracker) για την καταγραφή
            συμπτωμάτων υγείας και διάθεσης, την παροχή εξατομικευμένης καθοδήγησης με τη βοήθεια
            Τεχνητής Νοημοσύνης, καθώς και λειτουργικότητες διαχείρισης ραντεβού
            (συμπεριλαμβανομένων διασυνδέσεων με τρίτα μέρη). Η Πλατφόρμα μπορεί επίσης να
            διευκολύνει την υποβολή παραγγελιών από συνεργαζόμενα καταστήματα υγειονομικού
            ενδιαφέροντος και τη διαβίβασή τους μέσω δικτύου ανεξάρτητων διανομέων.
          </li>
          <li>
            <strong>«Επεξεργασία Δεδομένων Προσωπικού Χαρακτήρα»:</strong> Κάθε πράξη ή σειρά
            πράξεων που πραγματοποιείται, με ή χωρίς τη χρήση αυτοματοποιημένων μέσων, σε δεδομένα
            προσωπικού χαρακτήρα ή σε σύνολα δεδομένων προσωπικού χαρακτήρα, όπως η συλλογή,
            καταχώριση, οργάνωση, διάρθρωση, αποθήκευση, προσαρμογή ή μεταβολή, ανάκτηση, αναζήτηση
            πληροφοριών, χρήση, γνωστοποίηση με διαβίβαση, διάδοση ή κάθε άλλης μορφής διάθεση,
            συσχέτιση ή συνδυασμός, περιορισμός, διαγραφή ή καταστροφή.
          </li>
          <li>
            <strong>«Χρήση της Πλατφόρμας από ανηλίκους»:</strong> Η Πλατφόρμα και οι Υπηρεσίες μας
            προορίζονται για ενήλικες και δεν απευθύνονται σε παιδιά κάτω των 16 ετών. Δεν συλλέγουμε
            εν γνώσει μας προσωπικά δεδομένα από παιδιά κάτω των 16 ετών. Εάν αντιληφθούμε ότι έχουμε
            συλλέξει προσωπικά δεδομένα από παιδί κάτω των 16 ετών χωρίς την κατάλληλη γονική
            συγκατάθεση, θα προβούμε σε ενέργειες για τη διαγραφή αυτών των πληροφοριών. Εάν
            πιστεύετε ότι ένα παιδί μάς έχει παράσχει προσωπικά δεδομένα, επικοινωνήστε μαζί μας στο
            info@vivianlab.com.
          </li>
          <li>
            <strong>«Όχι αυτοματοποιημένες αποφάσεις με έννομες ή παρομοίως σημαντικές συνέπειες»:</strong>{' '}
            Δεν χρησιμοποιούμε τα προσωπικά σας δεδομένα για τη λήψη αποφάσεων που βασίζονται
            αποκλειστικά σε αυτοματοποιημένη επεξεργασία (συμπεριλαμβανομένης της κατάρτισης προφίλ),
            οι οποίες παράγουν έννομα αποτελέσματα που σας αφορούν ή σας επηρεάζουν παρομοίως
            σημαντικά κατά την έννοια του Άρθρου 22 του GDPR. Ο Βοηθός AI μας παρέχει μόνο γενικές
            πληροφορίες και προτάσεις ευεξίας και δεν λαμβάνει δεσμευτικές αποφάσεις σχετικά με την
            πρόσβασή σας σε υπηρεσίες, την ασφαλιστική κάλυψη, την απασχόληση ή παρόμοια ζητήματα.
          </li>
          <li>
            <strong>«Χρήση Τεχνητής Νοημοσύνης (Συστήματα AI)»:</strong> Η Πλατφόρμα μας περιλαμβάνει
            λειτουργίες που υποστηρίζονται από Τεχνητή Νοημοσύνη (AI), συμπεριλαμβανομένου ενός Βοηθού
            AI (AI Assistant) που χρησιμοποιείται για καθοδήγηση ευεξίας, καταγραφή συμπτωμάτων και
            εξατομικευμένο περιεχόμενο. Αυτά τα συστήματα λειτουργούν χρησιμοποιώντας μοντέλα
            μηχανικής μάθησης και παράγουν αποτελέσματα βάσει προτύπων σε δεδομένα και όχι βάσει
            ντετερμινιστικής λογικής.
          </li>
          <li>
            <strong>«Διαφάνεια Αλληλεπίδρασης με AI»:</strong> Όταν χρησιμοποιείτε λειτουργίες που
            υποστηρίζονται από ΤΝ, αλληλεπιδράτε με ένα αυτοματοποιημένο σύστημα και όχι με άνθρωπο.
            Ενημερώνουμε με σαφήνεια τους χρήστες εντός της διεπαφής (interface) κάθε φορά που παρέχεται
            περιεχόμενο παραγόμενο από ΤΝ, σύμφωνα με τους ισχύοντες κανονισμούς της ΕΕ.
          </li>
        </ul>
      </section>

      {/* 3. Σκοπός Επεξεργασίας και Διάρκεια */}
      <section>
        <h2>3. Σκοπός Επεξεργασίας και Διάρκεια</h2>
        <p>
          Επεξεργαζόμαστε τα προσωπικά σας δεδομένα με σκοπό την παροχή των προσφερόμενων Υπηρεσιών
          που περιγράφονται στην Πλατφόρμα μας. Ο ρόλος μας στην επεξεργασία των δεδομένων σας
          εξαρτάται από τη συγκεκριμένη περίπτωση και την Υπηρεσία που χρησιμοποιείτε:
        </p>
        <ul>
          <li>
            <strong>Όταν ενεργούμε ως Υπεύθυνος Επεξεργασίας:</strong>
            <br />
            Για δραστηριότητες όπως η διαχείριση του λογαριασμού χρήστη, η αποστολή
            ενημερωτικών/διαφημιστικών επικοινωνιών (newsletter) ή η παροχή του AI Assistant (AI
            Tracker), ενεργούμε ως Υπεύθυνος Επεξεργασίας. Σε αυτές τις περιπτώσεις, καθορίζουμε
            ανεξάρτητα τους σκοπούς και τις νομικές βάσεις (π.χ. εκτέλεση σύμβασης, συγκατάθεση ή
            έννομο συμφέρον) για την επεξεργασία.
          </li>
          <li>
            <strong>Όταν ενεργούμε ως Εκτελών την Επεξεργασία:</strong>
            <br />
            Όταν χρησιμοποιείτε την Πλατφόρμα για να αλληλεπιδράσετε ή να λάβετε υπηρεσίες από
            τρίτους (π.χ. «Specialists»), ο αντίστοιχος «Specialist» (που σας παρέχει τη
            συμβουλευτική) ενεργεί, κατά κανόνα, ως Υπεύθυνος Επεξεργασίας για τα δεδομένα που
            σχετίζονται με αυτή την υπηρεσία. Σε αυτή την περίπτωση, η Εταιρεία ενεργεί ως Εκτελών
            την Επεξεργασία, συλλέγοντας και επεξεργαζόμενη τα δεδομένα σας (π.χ. δεδομένα ραντεβού,
            σημειώσεις) αποκλειστικά για λογαριασμό και σύμφωνα με τη ρητή εντολή του εκάστοτε
            «Specialist». Η ευθύνη καθορισμού της νομικής βάσης (π.χ. συγκατάθεση για επεξεργασία
            δεδομένων υγείας) ανήκει στον Υπεύθυνο Επεξεργασίας (δηλ. στον «Specialist»).
          </li>
        </ul>
        <p>
          Θα χρησιμοποιούμε Δεδομένα Προσωπικού Χαρακτήρα μόνο όταν είναι απολύτως απαραίτητο για
          την εκπλήρωση των υποχρεώσεών μας, σύμφωνα με τους Γενικούς Όρους και την εφαρμοστέα
          νομοθεσία.
        </p>
        <p>
          Οι δραστηριότητες επεξεργασίας θα συνεχίζονται για όσο χρόνο απαιτείται για την παροχή των
          Υπηρεσιών και τη συμμόρφωση με τις νομικές μας υποχρεώσεις, όπως περιγράφεται λεπτομερώς
          στο Τμήμα 14 («Για πόσο χρόνο διατηρούμε τα δεδομένα σας;»).
        </p>
        <p>
          Ανεξάρτητα από τον ρόλο μας (Υπεύθυνος ή Εκτελών την Επεξεργασία), αντιμετωπίζουμε όλα τα
          Δεδομένα Προσωπικού Χαρακτήρα ως εμπιστευτικές προστατευόμενες πληροφορίες και εφαρμόζουμε
          αυστηρά τεχνικά και οργανωτικά μέτρα για την προστασία τους.
        </p>
      </section>

      {/* 4. Είναι υποχρεωτική η παροχή των Προσωπικών σας Δεδομένων; */}
      <section>
        <h2>4. Είναι υποχρεωτική η παροχή των Προσωπικών σας Δεδομένων;</h2>
        <p>
          Η παροχή των Δεδομένων στην Εταιρεία μπορεί να είναι αναγκαία για την επίτευξη των σκοπών
          που καθορίζονται στην παρούσα Πολιτική Απορρήτου ή μπορεί να είναι προαιρετική.
        </p>
        <p>
          Ο υποχρεωτικός ή προαιρετικός χαρακτήρας της παροχής των Δεδομένων υποδεικνύεται με
          αστερίσκο (*) δίπλα στα υποχρεωτικά προσωπικά δεδομένα.
        </p>
        <p>
          Εάν αρνηθείτε να παράσχετε τα δεδομένα που χαρακτηρίζονται ως υποχρεωτικά στην Πλατφόρμα,
          θα είναι αδύνατη η επίτευξη του κύριου σκοπού για τον οποίο συλλέγονται τα συγκεκριμένα
          Δεδομένα, και αυτό μπορεί, για παράδειγμα, να καταστήσει αδύνατη την εκπλήρωση της εκ
          μέρους μας υπηρεσίας ή την παροχή άλλων υπηρεσιών που είναι διαθέσιμες στους Ιστότοπους.
        </p>
        <p>
          Η παροχή επιπρόσθετων Δεδομένων, πέρα από εκείνα που χαρακτηρίζονται ως υποχρεωτικά, είναι
          προαιρετική και δεν έχει συνέπειες ως προς τους κύριους σκοπούς της συλλογής, καθώς η
          παροχή τους εξυπηρετεί αποκλειστικά τη βελτιστοποίηση της ποιότητας των υπηρεσιών που σας
          παρέχουμε.
        </p>
      </section>

      {/* 5. Ποια Προσωπικά Δεδομένα συλλέγουμε για εσάς; */}
      <section>
        <h2>5. Ποια Προσωπικά Δεδομένα συλλέγουμε για εσάς;</h2>
        <p>
          Μεριμνούμε να συλλέγουμε μόνο τα απολύτως απαραίτητα Δεδομένα Προσωπικού Χαρακτήρα,
          κατάλληλα και συναφή για τον επιδιωκόμενο σκοπό. Τα Δεδομένα αυτά περιλαμβάνουν:
        </p>
        <ul>
          <li>
            <strong>
              Δεδομένα που μας παρέχετε κατά την εγγραφή και δημιουργία λογαριασμού χρήστη:
            </strong>
            <br />
            Σύμφωνα με τη διαδικασία εγγραφής μας, συλλέγουμε υποχρεωτικά δεδομένα όπως
            Ονοματεπώνυμο, Διεύθυνση Email, Ημερομηνία Γέννησης, Χώρα και Πόλη.
            <br />
            Επεξεργαζόμαστε επίσης τον κωδικό πρόσβασής σας (ο οποίος αποθηκεύεται
            κρυπτογραφημένος).
            <br />
            Προαιρετικά μπορείτε να μας δώσετε και άλλα στοιχεία, όπως ταχυδρομική διεύθυνση ή
            αριθμό τηλεφώνου.
          </li>
          <li>
            <strong>
              Δεδομένα και πληροφορίες που μας παρέχετε μέσω συναλλαγών και επικοινωνίας:
            </strong>
            <br />
            Περιλαμβάνουν τις υπηρεσίες, επιλογές, συνεργασίες και επικοινωνία μεταξύ μας (μέσω της
            Πλατφόρμας, συνεργατών, τηλεφώνου, email ή άλλου μέσου).
            <br />
            Για παράδειγμα, συλλέγουμε σημειώσεις από τις συνομιλίες μας (δεδομένα επικοινωνίας),
            λεπτομέρειες τυχόν παραπόνων ή σχολίων, στοιχεία των υπηρεσιών που επιλέγετε,
            επαναλαμβανόμενες προτιμήσεις κ.λπ.
          </li>
          <li>
            <strong>Δεδομένα σχετικά με την επεξεργασία πληρωμών:</strong>
            <br />
            Πληροφορίες που απαιτούνται για την επεξεργασία πληρωμών και την ολοκλήρωση συναλλαγών,
            όπως διεύθυνση email, αριθμός τηλεφώνου, στοιχεία μεθόδου πληρωμής (όνομα κατόχου
            κάρτας, στοιχεία κάρτας) και διεύθυνση τιμολόγησης.
          </li>
          <li>
            <strong>Δεδομένα που μας παρέχετε κατά την εγγραφή στο newsletter:</strong>
            <br />
            Όπως Ονοματεπώνυμο και Διεύθυνση Email, τα οποία συλλέγονται βάσει της συναίνεσής σας.
          </li>
          <li>
            <strong>Δεδομένα για διασύνδεση με υπηρεσίες τρίτων:</strong>
            <br />
            Εάν επιλέξετε να συνδέσετε τον λογαριασμό σας, ενδέχεται να αποκτήσουμε πρόσβαση σε
            δεδομένα από το Google Calendar (όπως δημιουργία, ενημέρωση και διαγραφή ραντεβού) για
            τη διευκόλυνση της διαχείρισής τους. Αυτό συμβαίνει μόνο μετά από ρητή συναίνεσή σας
            (βλ. ενότητα «Διασύνδεση με Google Meet και Google Calendar»).
          </li>
          <li>
            <strong>Δεδομένα σχετικά με προτιμήσεις και χρήση της Πλατφόρμας:</strong>
            <br />
            Δεδομένα σχετικά με τις επιλογές και υπηρεσίες που επιλέγετε, με σκοπό την πρόταση
            υπηρεσιών που ενδέχεται να σας ενδιαφέρουν.
            <br />
            Πληροφορίες που συλλέγονται μέσω cookies στο πρόγραμμα περιήγησής σας (περισσότερα στην
            Πολιτική Cookies).
            <br />
            Τεχνικές πληροφορίες για τη σύνδεσή σας στο Internet και το πρόγραμμα περιήγησης, καθώς
            και τη χώρα και περιοχή, τις ιστοσελίδες που επισκέπτεστε, τις διαφημίσεις στις οποίες
            κάνετε κλικ και όρους αναζήτησης που εισάγετε.
          </li>
          <li>
            <strong>Δεδομένα από Social Media:</strong>
            <br />
            Το όνομα χρήστη σας στα μέσα κοινωνικής δικτύωσης, εφόσον αλληλεπιδράτε μαζί μας μέσω
            αυτών, ώστε να μπορούμε να απαντήσουμε σε σχόλια, ερωτήσεις ή παρατηρήσεις σας.
          </li>
          <li>
            <strong>Εκπαιδευτικά δεδομένα:</strong>
            <br />
            Όπως εκπαίδευση, δεξιότητες, γλωσσομάθεια, επαγγελματική εμπειρία (μόνο σε περιπτώσεις
            που ανταποκρίνεστε σε αγγελία εργασίας).
          </li>
          <li>
            <strong>Δεδομένα που συλλέγονται μέσω του AI Assistant (AI Tracker):</strong>
            <br />
            Αν επιλέξετε να χρησιμοποιήσετε τις λειτουργίες του AI Assistant, μπορείτε οικειοθελώς
            να μας παράσχετε ειδικές κατηγορίες (υγείας) δεδομένων προσωπικού χαρακτήρα.
            <br />
            Αυτά περιλαμβάνουν, ενδεικτικά: δεδομένα προφίλ (ηλικία, στάδιο εμμηνόπαυσης –
            peri/meno/post, lifestyle), δεδομένα συμπτωμάτων (π.χ. συχνότητα, ένταση), δεδομένα
            διάθεσης και συναισθηματικής κατάστασης, καθώς και βιομετρικά δεδομένα από συνδεδεμένες
            συσκευές (εφόσον υπάρχουν).
            <br />
            Τα δεδομένα αυτά τα συλλέγουμε αποκλειστικά βάσει της ρητής, ξεχωριστής και
            εξειδικευμένης συναίνεσής σας (άρθρο 9 GDPR), η οποία θα ζητηθεί πριν από την πρώτη
            χρήση οποιασδήποτε από αυτές τις λειτουργίες.
          </li>
          <li>
            Η Πλατφόρμα και οι Υπηρεσίες μας απευθύνονται αποκλειστικά σε ενήλικες και δεν
            προορίζονται για παιδιά κάτω των 16 ετών. Δεν συλλέγουμε εν γνώσει μας προσωπικά
            δεδομένα από παιδιά κάτω των 16 ετών. Εάν διαπιστώσουμε ότι έχουμε συλλέξει προσωπικά
            δεδομένα από παιδί κάτω των 16 ετών χωρίς την κατάλληλη γονική συναίνεση, θα λάβουμε
            μέτρα για τη διαγραφή των σχετικών πληροφοριών. Εάν πιστεύετε ότι ένα παιδί μας έχει
            παράσχει προσωπικά δεδομένα, παρακαλούμε επικοινωνήστε μαζί μας στο info@vivianlab.com
          </li>
        </ul>

        <h3>Χρήση Δεδομένων σε Συστήματα ΤΝ</h3>
        <p>
          Τα προσωπικά δεδομένα που παρέχετε στον Βοηθό ΤΝ χρησιμοποιούνται για τη δημιουργία
          εξατομικευμένων απαντήσεων και τη βελτίωση της εμπειρίας σας εντός της Πλατφόρμας. Δεν
          χρησιμοποιούμε τα ταυτοποιήσιμα προσωπικά σας δεδομένα για την εκπαίδευση εξωτερικών
          μοντέλων ΤΝ. Στις περιπτώσεις όπου τα δεδομένα χρησιμοποιούνται για τη βελτίωση των
          υπηρεσιών μας, αυτά καθίστανται συγκεντρωτικά, ανώνυμα ή ψευδωνυμοποιημένα, όπου αυτό είναι
          εφικτό.
        </p>

        <h3>
          <FormattedMessage id="ProfileImagesSection.titleWithNumber" values={{ number: '5.1' }} />
        </h3>
        <ul>
          <li>
            <FormattedMessage id="ProfileImagesSection.cameraAccess" />
          </li>
          <li>
            <FormattedMessage id="ProfileImagesSection.usage" />
          </li>
          <li>
            <FormattedMessage id="ProfileImagesSection.storage" />
          </li>
        </ul>
      </section>

      {/* 6. Διασύνδεση με Google Meet και Google Calendar */}
      <section>
        <h2>6. Διασύνδεση με Google Meet και Google Calendar</h2>
        <p>
          Σεβόμαστε ιδιαίτερα την ιδιωτικότητά σας και δεσμευόμαστε πλήρως για την προστασία των
          προσωπικών σας πληροφοριών. Η Πλατφόρμα μας διασυνδέεται με το Google Meet και το Google
          Calendar για να σας προσφέρει μια ομαλή, ασφαλή και φιλική εμπειρία προγραμματισμού και
          διαχείρισης διαδικτυακών συναντήσεων. Η διασύνδεση αυτή έχει σχεδιαστεί ώστε να απλοποιεί
          τη ροή εργασίας σας, επιτρέποντάς σας να οργανώνετε συναντήσεις απευθείας μέσα από την
          Πλατφόρμα χωρίς να απαιτείται χρήση εξωτερικών εργαλείων.
        </p>
        <p>
          Η χρήση αυτής της διασύνδεσης και η πρόσβαση στο Google Calendar σας απαιτεί ξεχωριστή και
          ρητή συναίνεση, η οποία θα ζητηθεί πριν συνδέσετε τον λογαριασμό σας. Διατηρείτε πάντοτε
          τον πλήρη έλεγχο και μπορείτε να τερματίσετε τη διασύνδεση και να ανακαλέσετε την πρόσβαση
          οποιαδήποτε στιγμή από τις ρυθμίσεις του λογαριασμού σας.
        </p>
        <h3>Πώς λειτουργεί η διασύνδεση:</h3>
        <p>
          Η ισχυρή διασύνδεσή μας με το Google Calendar API επιτρέπει στους χρήστες Google Account
          στην Πλατφόρμα να δημιουργούν, ενημερώνουν και διαγράφουν ραντεβού, με τους συνδέσμους
          (links) συναντήσεων να διαχειρίζονται αυτόματα μέσω του Google Calendar τους.
        </p>
        <p>
          Χρησιμοποιώντας το scope του Google Calendar API{' '}
          <a
            href="https://www.googleapis.com/auth/calendar.events.owned"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://www.googleapis.com/auth/calendar.events.owned
          </a>
          , διασφαλίζουμε μια ομαλή διαδικασία προγραμματισμού, τηρώντας παράλληλα αυστηρά πρότυπα
          ασφάλειας δεδομένων.
        </p>
        <h3>Η ιδιωτικότητά σας έχει σημασία:</h3>
        <p>
          Δεν κοινοποιούμε ούτε μεταφέρουμε τα δεδομένα χρήστη Google σε τρίτους, πέρα από ό,τι
          είναι απαραίτητο για τη βελτίωση και την παροχή αυτής της λειτουργικότητας
          προγραμματισμού.
        </p>
        <p>
          Η χρήση του Google Calendar API περιορίζεται αυστηρά στη βελτίωση της εμπειρίας σας
          σχετικά με τον προγραμματισμό και τη διαχείριση συναντήσεων.
        </p>
        <h3>Ασφάλεια δεδομένων και έλεγχος:</h3>
        <p>
          Διατηρείτε πλήρη έλεγχο στα ραντεβού σας, ενώ η διασύνδεση συμβάλλει στην παραγωγικότητα
          και την αποτελεσματικότητα χωρίς να υποβαθμίζει την ιδιωτικότητά σας.
        </p>
        <p>
          Έχουμε πρόσβαση μόνο στις απολύτως αναγκαίες πληροφορίες από το Google Calendar σας για
          την παροχή της συγκεκριμένης λειτουργίας, διασφαλίζοντας ότι όλες οι αλληλεπιδράσεις
          παραμένουν ασφαλείς.
        </p>
        <h3>Κοινοποίηση δεδομένων σε τρίτους:</h3>
        <p>
          Δεν κοινοποιούμε τα δεδομένα σας σε τρίτους πέρα από ό,τι απαιτείται για τη
          λειτουργικότητα του Google Meet και του Google Calendar, όπως περιγράφεται.
        </p>
        <p>
          Για περισσότερες πληροφορίες σχετικά με τον ασφαλή τρόπο που η Google διασφαλίζει την
          κοινοποίηση δεδομένων, μπορείτε να ανατρέξετε στη σχετική σελίδα υποστήριξης της Google.
        </p>
        <h3>Δέσμευση για ασφαλή επικοινωνία:</h3>
        <p>
          Η διασύνδεση με Google Meet αποτελεί μέρος της διαρκούς δέσμευσής μας να σας προσφέρουμε
          μια ασφαλή, αποτελεσματική και προσανατολισμένη στον χρήστη εμπειρία.
        </p>
        <p>
          Με την κεντρικοποίηση της διαχείρισης των συναντήσεών σας στην Πλατφόρμα, σας βοηθούμε να
          απλοποιήσετε τις διαδικασίες επικοινωνίας, τηρώντας ταυτόχρονα αυστηρές πρακτικές
          προστασίας δεδομένων.
        </p>
        <p>
          Για οποιαδήποτε απορία ή ανησυχία σχετικά με την ιδιωτικότητά σας και τη διασύνδεση με
          υπηρεσίες Google, μπορείτε να επικοινωνήσετε μαζί μας.
        </p>
      </section>

      {/* 7. Πώς χρησιμοποιούμε τα Προσωπικά σας Δεδομένα; */}
      <section>
        <h2>7. Πώς χρησιμοποιούμε τα Προσωπικά σας Δεδομένα;</h2>
        <p>Όπου εφαρμόζεται, χρησιμοποιούμε τα Δεδομένα σας ως εξής:</p>
        <ul>
          <li>
            <strong>Για ολοκλήρωση των επιλογών/υπηρεσιών (Εκτέλεση σύμβασης):</strong>
            <br />
            Η Εταιρεία επεξεργάζεται τα Δεδομένα σας προκειμένου να εκπληρώσει τη συμβατική της
            σχέση μαζί σας, να επεξεργαστεί την επιλογή υπηρεσιών, να παρέχει εξυπηρέτηση πελατών,
            να συμμορφωθεί με νομικές υποχρεώσεις, να διαχειριστεί πληρωμές, να ασκήσει ή να
            υπερασπιστεί νομικές αξιώσεις.
            <br />
            Αν δεν συλλέξουμε τα Δεδομένα σας κατά την ολοκλήρωση της επιλογής (μέσω τηλεφωνικής ή
            ηλεκτρονικής υπηρεσίας), δεν θα μπορούμε να επεξεργαστούμε την επιλογή σας και να
            συμμορφωθούμε με τις νομικές μας υποχρεώσεις.
            <br />
            Ενδέχεται να χρειαστεί η διαβίβαση Δεδομένων σε τρίτους για την εξυπηρέτηση και
            επεξεργασία της υπηρεσίας που έχετε επιλέξει (βλ. κατωτέρω «Ποιοι είναι οι αποδέκτες»).
            <br />
            Επίσης, μπορεί να διατηρήσουμε τα Δεδομένα σας για εύλογο χρονικό διάστημα, ώστε να
            εκπληρώσουμε τις συμβατικές μας υποχρεώσεις, όπως προβλέπεται από την κείμενη νομοθεσία.
          </li>
          <li>
            <strong>
              Για δημιουργία λογαριασμού χρήστη (Εκτέλεση σύμβασης και έννομο συμφέρον):
            </strong>
            <br />Η Εταιρεία επεξεργάζεται τα Δεδομένα σας για να σας παρέχει λειτουργίες
            λογαριασμού και να διευκολύνει τη σύναψη υπηρεσιών μέσω της Πλατφόρμας.
          </li>
          <li>
            <strong>Για παροχή υπηρεσιών AI Assistant (Ρητή συναίνεση):</strong>
            <br />
            Η Εταιρεία επεξεργάζεται τα Δεδομένα σας για να:
            <br />
            επιτρέψει την καταγραφή και παρακολούθηση των συμπτωμάτων υγείας σας,
            <br />
            παρέχει καθοδήγηση με τη βοήθεια Τεχνητής Νοημοσύνης, εξατομικευμένη υποστήριξη και
            προτάσεις σχετικές με την υγεία σας, βάσει των δεδομένων που εισάγετε.
            <br />
            Σημείωση: Η επεξεργασία ειδικών κατηγοριών (υγείας) δεδομένων για τους σκοπούς αυτούς
            γίνεται αποκλειστικά βάσει της ρητής και ξεχωριστής συναίνεσής σας (άρθρο 9 GDPR).
          </li>
        </ul>
        <h3>Σκοπός και Περιορισμοί της ΤΝ</h3>
        <p>
          Ο Βοηθός ΤΝ έχει σχεδιαστεί αποκλειστικά για σκοπούς γενικής ευεξίας, εκπαίδευσης και
          ενημέρωσης. Δεν παρέχει ιατρικές συμβουλές, διάγνωση, θεραπεία ή υποστήριξη κλινικών
          αποφάσεων. Τα αποτελέσματα που παράγονται από την AI ενδέχεται να είναι ελλιπή, ανακριβή ή
          να μην είναι προσαρμοσμένα στη συγκεκριμένη ιατρική σας κατάσταση. Δεν πρέπει να βασίζεστε
          σε περιεχόμενο που παράγεται από ΤΝ για ιατρικές αποφάσεις και πρέπει πάντα να συμβουλεύεστε
          έναν εξειδικευμένο επαγγελματία υγείας.
        </p>
        <ul>
          <li>
            <strong>Για διασύνδεση με Google Meet και Google Calendar (Ρητή συναίνεση):</strong>
            <br />Η Εταιρεία επεξεργάζεται τα Δεδομένα σας για να διευκολύνει τη δημιουργία,
            ενημέρωση και διαγραφή ραντεβού απευθείας μέσω της Πλατφόρμας, συγχρονίζοντάς τα με το
            Google Calendar σας. Η λειτουργία αυτή ενεργοποιείται αποκλειστικά βάσει της ρητής και
            ξεχωριστής συναίνεσής σας.
          </li>
          <li>
            <strong>Για Επικοινωνία (Έννομο συμφέρον):</strong>
            <br />
            Χρησιμοποιούμε τα Δεδομένα σας για να απαντούμε σε αιτήματά σας/ερωτήσεις, αιτήματα
            επιστροφής χρημάτων και/ή παράπονα. Οι πληροφορίες που μοιράζεστε μαζί μας μάς
            επιτρέπουν να διαχειριστούμε τα αιτήματά σας και να σας απαντήσουμε με τον καλύτερο
            δυνατό τρόπο. Μπορεί επίσης να τηρούμε αρχείο των επικοινωνιών σας μαζί μας, ώστε να
            ανταποκρινόμαστε καλύτερα σε μελλοντικά αιτήματά σας. Αυτό γίνεται βάσει συμβατικών και
            νομικών υποχρεώσεών μας καθώς και εννόμου συμφέροντος για βελτίωση των υπηρεσιών μας.
          </li>
          <li>
            <strong>Για αποστολή newsletters / προσφορών (Συναίνεση):</strong>
            <br />
            Με τη συναίνεσή σας, χρησιμοποιούμε τα Προσωπικά σας Δεδομένα, τις προτιμήσεις και τα
            στοιχεία συναλλαγών σας για να σας ενημερώνουμε μέσω email, διαδικτύου, τηλεφώνου και/ή
            social media για συναφείς υπηρεσίες, συμπεριλαμβανομένων εξατομικευμένων προσφορών.
            Μπορείτε να ανακαλέσετε τη συναίνεση αυτή οποιαδήποτε στιγμή.
          </li>
          <li>
            <strong>Για Web push notifications (Συναίνεση):</strong>
            <br />
            Ανάλογα με την πλοήγησή σας, και αφού προηγουμένως δώσετε τη συγκατάθεσή σας, μπορεί να
            λαμβάνετε ειδοποιήσεις για προσφορές, νέα, wish list και βασικές προτιμήσεις σας.
            Μπορείτε να ανακαλέσετε τη συγκατάθεσή σας οποιαδήποτε στιγμή.
          </li>
          <li>
            <strong>Για συμμετοχή σε πρόγραμμα επιβράβευσης:</strong>
            <br />Η Εταιρεία μπορεί να επεξεργαστεί τα Δεδομένα σας για τις ανάγκες συμμετοχής σας
            σε πρόγραμμα επιβράβευσης, δηλαδή για εξέταση της αίτησης συμμετοχής, συλλογή/εξαργύρωση
            πόντων και απόλαυση προνομίων, όπως αυτά θα αναλύονται στους όρους του προγράμματος.
          </li>
          <li>
            <strong>Για ανάπτυξη και βελτίωση υπηρεσιών:</strong>
            <br />
            Χρησιμοποιούμε τα Δεδομένα σας για να βελτιώνουμε τις επιλογές, προσφορές, λειτουργία
            και υπηρεσίες μας, βάσει εννόμου επιχειρηματικού συμφέροντος.
          </li>
          <li>
            <strong>Για παροχή πιο σχετικών προτάσεων/περιεχομένου:</strong>
            <br />
            Χρησιμοποιούμε τα Δεδομένα σας (και, όπου απαιτείται, τη συγκατάθεσή σας για
            cookies/notifications) ώστε να εμφανίζουμε πιο συναφές περιεχόμενο (π.χ. λίστα πρόσφατα
            προβληθέντων υπηρεσιών, προτάσεις βάσει ιστορικού επιλογών).
          </li>
          <li>
            <strong>Για αποστολή ερευνών/αξιολογήσεων:</strong>
            <br />
            Σας αποστέλλουμε αιτήματα αξιολόγησης ώστε να βελτιώνουμε τις υπηρεσίες μας. Τα μηνύματα
            αυτά δεν περιέχουν διαφημιστικό περιεχόμενο και δεν απαιτούν προηγούμενη συγκατάθεση
            όταν αποστέλλονται μέσω email ή SMS, καθώς βασίζονται σε έννομο συμφέρον.
          </li>
          <li>
            <strong>Για προστασία του λογαριασμού από απάτη και παράνομες δραστηριότητες:</strong>
            <br />
            Χρησιμοποιούμε τα Δεδομένα σας για να διατηρούμε, ενημερώνουμε και προστατεύουμε τον
            λογαριασμό σας και να εντοπίζουμε τυχόν ύποπτη δραστηριότητα ή απόπειρες απάτης.
          </li>
          <li>
            <strong>
              Για επεξεργασία πληρωμών και πρόληψη απάτης (Έννομο συμφέρον και νομική υποχρέωση):
            </strong>
            <br />
            Προστατεύουμε τόσο εσάς όσο και την Εταιρεία από δόλιες συναλλαγές, κυβερνοεπιθέσεις και
            λοιπές παράνομες πράξεις.
          </li>
          <li>
            <strong>Για συμμόρφωση με νομικές υποχρεώσεις:</strong>
            <br />
            Χρησιμοποιούμε τα Δεδομένα σας για να αποστείλουμε υποχρεωτικές ενημερώσεις ή για
            συμμόρφωση με δικαστικές/νομικές υποχρεώσεις (π.χ. ενημέρωση για αλλαγές όρων,
            ειδοποιήσεις αποχώρησης υπηρεσιών).
          </li>
          <li>
            <strong>Επεξεργασία για λογαριασμό «Specialists» (ως Εκτελών):</strong>
            <br />
            Όταν αλληλεπιδράτε με «Specialist» μέσω της Πλατφόρμας, επεξεργαζόμαστε τα δεδομένα σας
            (περιεχόμενο επικοινωνίας, ραντεβού κ.λπ.) ως Εκτελών την Επεξεργασία, για λογαριασμό
            του «Specialist», με σκοπό την εκπλήρωση των συμβατικών μας υποχρεώσεων προς αυτόν και
            τη διευκόλυνση της παροχής υπηρεσιών προς εσάς.
          </li>
        </ul>
        <p>
          Η επεξεργασία γίνεται είτε από ειδικά εξουσιοδοτημένο προσωπικό της Εταιρείας, είτε μέσω
          πληροφοριακών συστημάτων και ηλεκτρονικών συσκευών της Εταιρείας, είτε, κατ’ εξαίρεση, από
          τρίτους που έχουν συμβατικά δεσμευτεί για τήρηση εμπιστευτικότητας και προστασίας των
          δεδομένων σας και εκτελούν εργασίες αναγκαίες για την επίτευξη των σκοπών που σχετίζονται
          αυστηρά με τη χρήση της Πλατφόρμας και των υπηρεσιών της.
        </p>
      </section>

      {/* 8. Ποια είναι η νομική βάση επεξεργασίας των Δεδομένων σας; */}
      <section>
        <h2>8. Ποια είναι η νομική βάση επεξεργασίας των Δεδομένων σας;</h2>
        <p>
          Επεξεργαζόμαστε τα προσωπικά σας δεδομένα νόμιμα, με διαφάνεια και καλή πίστη. Ανάλογα με
          τον σκοπό (βλ. ενότητα 7), στηριζόμαστε στις ακόλουθες νομικές βάσεις του GDPR:
        </p>
        <ul>
          <li>
            <strong>Εκτέλεση σύμβασης (άρθρο 6 παρ. 1(b) GDPR):</strong>
            <br />
            Όταν η επεξεργασία είναι απαραίτητη για σύναψη ή εκτέλεση σύμβασης με εσάς (π.χ.
            δημιουργία λογαριασμού, παροχή υπηρεσιών, επεξεργασία πληρωμών).
          </li>
          <li>
            <strong>Συμμόρφωση με νομική υποχρέωση (άρθρο 6 παρ. 1(c) GDPR):</strong>
            <br />
            Όταν απαιτείται βάσει νόμου (π.χ. τήρηση τιμολογίων και στοιχείων συναλλαγών για
            φορολογικούς/λογιστικούς λόγους, απάντηση σε αιτήματα αρχών).
          </li>
          <li>
            <strong>Συναίνεση (άρθρο 6 παρ. 1(a) GDPR):</strong>
            <br />
            Για δραστηριότητες που δεν καλύπτονται από άλλες βάσεις, όπως: αποστολή newsletter,
            marketing επικοινωνίες, web push notifications, χρήση αναλυτικών/διαφημιστικών cookies,
            ενεργοποίηση AI Assistant με δεδομένα υγείας, διασύνδεση με Google Calendar.
          </li>
          <li>
            <strong>Έννομο συμφέρον (άρθρο 6 παρ. 1(f) GDPR):</strong>
            <br />
            Όταν η επεξεργασία είναι απαραίτητη για επιδίωξη δικού μας έννομου συμφέροντος, υπό την
            προϋπόθεση ότι δεν υπερισχύουν τα θεμελιώδη δικαιώματα και ελευθερίες σας (π.χ.
            προστασία λογαριασμού από απάτη, βελτίωση υπηρεσιών).
          </li>
          <li>
            <strong>Επεξεργασία Ειδικών Κατηγοριών Δεδομένων (άρθρο 9 GDPR):</strong>
            <br />
            Για επεξεργασία ειδικών κατηγοριών δεδομένων (υγείας, βιομετρικών κ.λπ.) που παρέχετε
            στον AI Assistant (AI Tracker), δεν βασιζόμαστε στις ανωτέρω βάσεις.
            <br />Η μοναδική νομική βάση είναι η ΡΗΤΗ ΚΑΙ ΞΕΧΩΡΙΣΤΗ ΣΥΝΑΙΝΕΣΗ σας (άρθρο 9 παρ. 2(α)
            GDPR), την οποία ζητούμε πριν την πρώτη χρήση της σχετικής λειτουργίας.
          </li>
        </ul>
        <p>
          Κατά τη συλλογή δεδομένων, σας ενημερώνουμε πάντοτε ποια είναι υποχρεωτικά (*) και ποια
          προαιρετικά, καθώς και τις συνέπειες μη παροχής τους.
        </p>
      </section>

      {/* 9. Ποιοι είναι οι αποδέκτες των Δεδομένων σας; */}
      <section>
        <h2>9. Ποιοι είναι οι αποδέκτες των Δεδομένων σας;</h2>
        <p>Πρόσβαση στα Δεδομένα σας έχει μόνο:</p>
        <ul>
          <li>
            Το απολύτως αναγκαίο προσωπικό της Εταιρείας, που δεσμεύεται συμβατικά με υποχρέωση
            εμπιστευτικότητας.
          </li>
          <li>
            Συνεργαζόμενες εταιρείες και πάροχοι υπηρεσιών τρίτων (Εκτελούντες την Επεξεργασία), που
            επεξεργάζονται τα Δεδομένα σας για λογαριασμό μας και σύμφωνα με τις εντολές μας.
          </li>
        </ul>
      </section>

      {/* 10. Πώς κοινοποιούνται τα Δεδομένα σας; */}
      <section>
        <h2>10. Πώς κοινοποιούνται τα Δεδομένα σας;</h2>
        <h3>10.1 Πάροχοι Υπηρεσιών Τρίτων (Εκτελούντες την Επεξεργασία):</h3>
        <p>
          Πρόκειται για εταιρείες που επεξεργάζονται προσωπικά δεδομένα για λογαριασμό μας και κατ’
          εντολή μας, δυνάμει συμβάσεων (DPA) που επιβάλλουν την εφαρμογή κατάλληλων τεχνικών και
          οργανωτικών μέτρων. Ενδεικτικά:
        </p>
        <ul>
          <li>
            Πάροχοι φιλοξενίας & υποδομής cloud: Εταιρείες που παρέχουν χώρο σε διακομιστές (servers)
            και υποδομές για τη λειτουργία της Πλατφόρμας (π.χ. AWS, Render).
          </li>
          <li>
            Πάροχοι υπηρεσιών ΤΝ (AI): Για τη λειτουργία του AI Assistant (AI Tracker), διαβιβάζουμε
            δεδομένα (συμπεριλαμβανομένων δεδομένων υγείας, μόνο κατόπιν ρητής συναίνεσής σας) στον
            τεχνολογικό μας συνεργάτη Anthropic (Claude AI), με έδρα στις ΗΠΑ.
          </li>
          <li>
            Διαφάνεια Παρόχων Υπηρεσιών Τεχνητής Νοημοσύνης (AI): Κατά τη χρήση λειτουργιών Τεχνητής
            Νοημοσύνης (AI), τα δεδομένα σας ενδέχεται να υποβληθούν σε επεξεργασία από τρίτους
            παρόχους υπηρεσιών AI που ενεργούν ως Εκτελούντες την Επεξεργασία. Αυτοί οι πάροχοι
            επεξεργάζονται τα δεδομένα αποκλειστικά βάσει των οδηγιών μας και δεσμεύονται συμβατικά να
            μη χρησιμοποιούν τα προσωπικά σας δεδομένα για δικούς τους ανεξάρτητους σκοπούς.
          </li>
          <li>
            Εφαρμόζουμε τα κατάλληλα μέτρα προστασίας, συμπεριλαμβανομένης της ελαχιστοποίησης των
            δεδομένων, της κρυπτογράφησης και των συμβατικών περιορισμών, προκειμένου να διασφαλίσουμε
            ότι οι πάροχοι AI επεξεργάζονται τα δεδομένα σας σε συμμόρφωση με τον GDPR και τους
            ισχύοντες κανονισμούς περί Τεχνητής Νοημοσύνης.
          </li>
          <li>
            Πάροχοι υπηρεσιών πληρωμών (PSPs): Για επεξεργασία καρτών και πληρωμών. Δεν αποθηκεύουμε τα
            στοιχεία της κάρτας σας· αυτά επεξεργάζονται απευθείας από τους παρόχους πληρωμών, οι
            οποίοι είναι πιστοποιημένοι PCI DSS.
          </li>
          <li>
            Πάροχοι υπηρεσιών αναλύσεων (Analytics): Προκειμένου να κατανοήσουμε πώς χρησιμοποιείται η
            Πλατφόρμα μας, μοιραζόμαστε δεδομένα (π.χ. μέσω cookies) με συνεργάτες όπως η Google
            Analytics.
          </li>
          <li>
            Πάροχοι Υπηρεσιών Μάρκετινγκ και Επικοινωνίας: Για τη διανομή μηνυμάτων ηλεκτρονικού
            ταχυδρομείου (newsletter), τη διενέργεια ερευνών και αναλύσεων. Δεν προβαίνουμε σε πώληση,
            εκμίσθωση ή ανταλλαγή των προσωπικών σας δεδομένων με τρίτα μέρη έναντι χρηματικού
            ανταλλάγματος.
          </li>
        </ul>

        <h3>10.2 «Specialists» (ως Υπεύθυνοι Επεξεργασίας):</h3>
        <p>
          Όταν, ως «User», έρχεστε σε επαφή ή κλείνετε υπηρεσία μέσω της Πλατφόρμας με «Specialist»,
          κοινοποιούμε στον «Specialist» τα απαραίτητα δεδομένα (π.χ. όνομα, email, δεδομένα
          ραντεβού, ενδεχομένως δεδομένα υγείας που εισάγετε). Σε αυτή την περίπτωση, ο «Specialist»
          ενεργεί ως ανεξάρτητος Υπεύθυνος Επεξεργασίας και εμείς ως Εκτελών την Επεξεργασία.
        </p>

        <h3>10.3 Άλλοι τρίτοι (με τη συναίνεσή σας ή κατόπιν πρωτοβουλίας σας):</h3>
        <p>Τρίτοι στους οποίους επιλέγετε εσείς να κοινοποιήσετε δεδομένα (π.χ. διασύνδεση Google Calendar).</p>

        <h3>10.4 Δημόσιες Αρχές και νομικές υποχρεώσεις:</h3>
        <p>Κοινοποιούμε δεδομένα με άλλα τρίτα μέρη στον βαθμό που απαιτείται για τους ακόλουθους σκοπούς:</p>
        <ul>
          <li>
            (i) Συμμόρφωση κατόπιν αιτήματος αρμόδιας κυβερνητικής αρχής της Ελλάδας, δικαστικής
            απόφασης ή ισχύοντος νόμου.
          </li>
          <li>
            (ii) Πρόληψη παράνομων χρήσεων της Πλατφόρμας μας ή παραβιάσεων των Όρων Χρήσης και των
            πολιτικών μας.
          </li>
          <li>(iii) Προστασία της ίδιας της εταιρείας έναντι αξιώσεων τρίτων.</li>
          <li>(iv) Συμβολή στην πρόληψη ή τη διερεύνηση περιπτώσεων απάτης.</li>
        </ul>

        <h3>10.5 Κοινή Χρήση Δεδομένων από εσάς</h3>
        <p>
          Όταν χρησιμοποιείτε ορισμένες λειτουργίες μέσων κοινωνικής δικτύωσης στην Πλατφόρμα μας,
          ενδέχεται να δημιουργήσετε ένα δημόσιο προφίλ που περιλαμβάνει πληροφορίες όπως το όνομα
          χρήστη (username), τη φωτογραφία προφίλ και την πόλη σας. Μπορείτε επίσης να μοιράζεστε
          περιεχόμενο με τους φίλους σας ή το ευρύ κοινό, συμπεριλαμβανομένων πληροφοριών σχετικά με
          την αλληλεπίδρασή σας με την Εταιρεία. Σας ενθαρρύνουμε να χρησιμοποιείτε τα εργαλεία που
          παρέχουμε για τη διαχείριση της κοινής χρήσης στα μέσα κοινωνικής δικτύωσης της Εταιρείας,
          προκειμένου να ελέγχετε τις πληροφορίες που παρέχετε.
        </p>
      </section>

      {/* 11. Πολιτική μας για τους Εκτελούντες την Επεξεργασία */}
      <section>
        <h2>11. Πολιτική μας για τους Εκτελούντες την Επεξεργασία</h2>
        <p>Όσοι εκτελούν την επεξεργασία για λογαριασμό μας έχουν συμφωνήσει και δεσμευτεί με σύμβαση έναντι της Εταιρείας να:</p>
        <ul>
          <li>Τηρούν την εμπιστευτικότητα.</li>
          <li>Μη διαβιβάζουν τα Δεδομένα σας σε τρίτους χωρίς την άδεια της Εταιρείας.</li>
          <li>Λαμβάνουν κατάλληλα μέτρα ασφαλείας.</li>
          <li>Συμμορφώνονται με το νομικό πλαίσιο για την προστασία των προσωπικών δεδομένων και ειδικότερα με τον GDPR.</li>
        </ul>
        <p>
          Προκειμένου να βελτιώσουμε την εμπειρία σας ως πελάτες στους Ιστότοπους και τις Εφαρμογές
          μας, χρησιμοποιούμε τους προαναφερθέντες παρόχους υπηρεσιών, οι οποίοι θα επεξεργάζονται τα
          Προσωπικά σας Δεδομένα στο πλαίσιο των συμβάσεών τους μαζί μας. Εάν επιθυμείτε να λάβετε
          περισσότερες πληροφορίες σχετικά με την κοινοποίηση των Δεδομένων σας σε τρίτα μέρη,
          παρακαλούμε επικοινωνήστε μαζί μας μέσω email στη διεύθυνση info@vivianlab.com.
        </p>
      </section>

      {/* 12. Πώς διασφαλίζουμε ότι οι Εκτελούντες σέβονται τα Δεδομένα σας; */}
      <section>
        <h2>12. Πώς διασφαλίζουμε ότι οι Εκτελούντες σέβονται τα Δεδομένα σας;</h2>
        <p>Όσοι επεξεργάζονται δεδομένα για λογαριασμό μας έχουν συμφωνήσει και δεσμευτεί με σύμβαση:</p>
        <ul>
          <li>Να τηρούν την εμπιστευτικότητα.</li>
          <li>Να μη διαβιβάζουν τα Δεδομένα σας σε τρίτους χωρίς άδεια της Εταιρείας.</li>
          <li>Να λαμβάνουν κατάλληλα μέτρα ασφάλειας.</li>
          <li>Να συμμορφώνονται με το νομικό πλαίσιο προστασίας δεδομένων και ειδικότερα με τον GDPR.</li>
        </ul>
      </section>

      {/* 13. Διαβίβαση Δεδομένων */}
      <section>
        <h2>13. Διαβίβαση Δεδομένων</h2>
        <p>
          Τα προσωπικά δεδομένα που συλλέγουμε (ή επεξεργαζόμαστε) στο πλαίσιο της Πλατφόρμας μας θα
          αποθηκεύονται κυρίως εντός της Ευρωπαϊκής Ένωσης (ΕΕ) και του Ευρωπαϊκού Οικονομικού Χώρου
          (ΕΟΧ), για παράδειγμα στους κύριους διακομιστές μας που φιλοξενούνται στη Γερμανία.
        </p>
        <p>
          Ωστόσο, για την παροχή ορισμένων Υπηρεσιών και λειτουργιών, ορισμένοι από τους αποδέκτες
          Δεδομένων με τους οποίους η Εταιρεία μοιράζεται τα Προσωπικά σας Δεδομένα ενδέχεται να
          βρίσκονται σε χώρες εκτός του ΕΟΧ («τρίτες χώρες»). Αυτό περιλαμβάνει ιδίως:
        </p>
        <p>
          α) Πάροχος Φιλοξενίας και Υποδομής Cloud: Στο βαθμό που η VivianLab LTD χρησιμοποιεί την
          Amazon Web Services, Inc. («AWS») ως πάροχο φιλοξενίας και υποδομής cloud για την επεξεργασία
          των προσωπικών σας δεδομένων, η AWS ενεργεί ως Εκτελών την Επεξεργασία για λογαριασμό της
          Εταιρείας σύμφωνα με τον GDPR. Η σχέση μεταξύ της Εταιρείας και της AWS διέπεται από το
          Παράρτημα Επεξεργασίας Δεδομένων της AWS («AWS DPA»), το οποίο ενσωματώνεται στους Όρους
          Παροχής Υπηρεσιών της AWS. Στις περιπτώσεις όπου οι υπηρεσίες της AWS περιλαμβάνουν τη
          διαβίβαση των προσωπικών σας δεδομένων από τον ΕΟΧ σε χώρες εκτός αυτού (συμπεριλαμβανομένων
          των ΗΠΑ), η Εταιρεία διασφαλίζει τις κατάλληλες εγγυήσεις σύμφωνα με το Άρθρο 46 του GDPR,
          ιδίως μέσω των Τυποποιημένων Συμβατικών Ρητρών (SCCs).
        </p>
        <p>
          β) Πάροχοι Υπηρεσιών AI: Για τη λειτουργία του Βοηθού AI (AI Tracker), διαβιβάζουμε δεδομένα
          στον τεχνολογικό μας συνεργάτη Anthropic (Claude AI), ο οποίος εδρεύει στις Ηνωμένες
          Πολιτείες Αμερικής (ΗΠΑ).
        </p>
        <p>
          γ) Πάροχοι Υπηρεσιών Αναλύσεων: Για σκοπούς ανάλυσης ιστού, χρησιμοποιούμε υπηρεσίες όπως η
          Google Analytics, οι οποίες ενδέχεται να περιλαμβάνουν διαβίβαση δεδομένων στις ΗΠΑ.
        </p>
        <p>
          Η νομοθεσία σε αυτές τις χώρες (όπως οι ΗΠΑ) ενδέχεται να μην παρέχει το ίδιο επίπεδο
          προστασίας δεδομένων σε σύγκριση με τον ΕΟΧ. Δεσμευόμαστε να προστατεύουμε τα Προσωπικά σας
          Δεδομένα και λαμβάνουμε όλα τα απαραίτητα μέτρα για τη συμμόρφωση με τις ισχύουσες νομικές
          απαιτήσεις για τέτοιες διαβιβάσεις. Για να διασφαλίσουμε ότι τα Προσωπικά σας Δεδομένα
          προστατεύονται επαρκώς, βασιζόμαστε κυρίως στις Τυποποιημένες Συμβατικές Ρήτρες (SCCs) που
          έχουν εγκριθεί από την Ευρωπαϊκή Επιτροπή.
        </p>
        <p>
          Ειδικά για τη διαβίβαση των δεδομένων ειδικών κατηγοριών (υγείας) στους συνεργάτες μας AI
          στις ΗΠΑ, επιπλέον των Τυποποιημένων Συμβατικών Ρητρών, θα βασιστούμε επίσης στη ρητή και
          χωριστή συγκατάθεσή σας για τη διαβίβαση αυτή, η οποία θα ζητηθεί πριν χρησιμοποιήσετε την
          υπηρεσία του Βοηθού AI. Χρησιμοποιώντας την Πλατφόρμα, αναγνωρίζετε ότι τα δεδομένα σας
          ενδέχεται να διαβιβαστούν και να υποβληθούν σε επεξεργασία σε χώρες εκτός της δικαιοδοσίας
          σας, συμπεριλαμβανομένων των Ηνωμένων Πολιτειών, όπου οι νόμοι περί προστασίας δεδομένων
          ενδέχεται να διαφέρουν από εκείνους της χώρας σας.
        </p>
      </section>

      {/* 14. Για πόσο χρόνο διατηρούμε τα Δεδομένα σας; */}
      <section>
        <h2>14. Για πόσο χρόνο διατηρούμε τα Δεδομένα σας;</h2>
        <p>
          Διατηρούμε τα Προσωπικά σας Δεδομένα για όσο διάστημα είναι απαραίτητο για την εκπλήρωση των
          σκοπών που ορίζονται στην παρούσα Πολιτική Απορρήτου (εκτός εάν απαιτείται μεγαλύτερη
          περίοδος διατήρησης από την ισχύουσα νομοθεσία).
        </p>
        <p>
          Γενικά, αυτό σημαίνει ότι θα αποθηκεύουμε τα Προσωπικά Δεδομένα που σχετίζονται με τον
          λογαριασμό σας για όσο διάστημα διατηρείτε ενεργό λογαριασμό στην Εταιρεία μας.
        </p>
        <p>
          Όσον αφορά τα Προσωπικά σας Δεδομένα που σχετίζονται με τις υπηρεσίες που προσφέρουμε (π.χ.
          δεδομένα συναλλαγών), αποθηκεύουμε αυτά τα δεδομένα για μεγαλύτερο χρονικό διάστημα
          προκειμένου να συμμορφωθούμε με τις νομικές μας υποχρεώσεις (όπως η φορολογική και εμπορική
          νομοθεσία).
        </p>
        <p>
          Στο τέλος αυτής της περιόδου διατήρησης, τα δεδομένα σας θα διαγραφούν πλήρως ή θα
          ανωνυμοποιηθούν, για παράδειγμα μέσω της συγκέντρωσής τους με άλλα δεδομένα, έτσι ώστε να
          μπορούν να χρησιμοποιηθούν με μη ταυτοποιήσιμο τρόπο για στατιστική ανάλυση και επιχειρηματικό
          σχεδιασμό.
        </p>
        <p>Ορισμένα παραδείγματα περιόδων διατήρησης:</p>
        <ul>
          <li>
            Δεδομένα Λογαριασμού και Υπηρεσιών (Μητρώο Πελατών): Αποθηκεύουμε τα βασικά δεδομένα του
            λογαριασμού σας όσο αυτός είναι ενεργός. Τα δεδομένα που σχετίζονται με συναλλαγές και την
            εκτέλεση υπηρεσιών αποθηκεύονται για πέντε (5) έτη μετά τη λήξη της συμβατικής σχέσης.
          </li>
          <li>
            Δεδομένα Newsletter (Μητρώο Μάρκετινγκ): Η συγκατάθεσή σας και τα δεδομένα για την αποστολή
            του ενημερωτικού δελτίου (όνομα, email) αποθηκεύονται μέχρι να ανακαλέσετε τη συγκατάθεσή
            σας.
          </li>
          <li>
            Δεδομένα Βοηθού AI (Μητρώο AI Tracker): Λόγω της ευαίσθητης φύσης αυτών των δεδομένων,
            εφαρμόζουμε τα ακόλουθα χρονικά όρια: υποβάλλονται σε ενεργή επεξεργασία όσο χρησιμοποιείτε
            τη λειτουργία. Εάν καταστείτε ανενεργός, ενδέχεται να διατηρήσουμε τα δεδομένα για
            περιορισμένο χρονικό διάστημα (π.χ. 18 μήνες μετά την τελευταία σας δραστηριότητα). Με το
            ρητό κλείσιμο του προφίλ σας ή κατόπιν αιτήματός σας για διαγραφή, τα προσωπικά σας δεδομένα
            υγείας από τον Βοηθό AI θα διαγράφονται οριστικά.
          </li>
        </ul>
      </section>

      {/* 15. Είναι ασφαλή τα Δεδομένα σας; */}
      <section>
        <h2>15. Είναι ασφαλή τα Δεδομένα σας;</h2>
        <p>
          Η VivianLab δεσμεύεται να προστατεύει τα Προσωπικά σας Δεδομένα με μέτρα ασφάλειας υψηλού
          επιπέδου, τόσο τεχνικά όσο και οργανωτικά, σε όλο τον κύκλο ζωής των δεδομένων.
        </p>
        <h3>15.1 Τεχνικά μέτρα ασφάλειας</h3>
        <ul>
          <li>
            Κρυπτογράφηση κατά τη μεταφορά (Encryption in transit): Όλα τα δεδομένα που μεταδίδονται
            μεταξύ της συσκευής σας και των servers μας προστατεύονται μέσω HTTPS με TLS 1.2 ή νεότερο,
            ώστε να αποτρέπεται υποκλοπή ή αλλοίωση.
          </li>
          <li>
            Κρυπτογράφηση σε κατάσταση ηρεμίας (Encryption at rest): Τα δεδομένα αποθηκεύονται
            κρυπτογραφημένα (π.χ. AES-256) σε βάσεις δεδομένων και συστήματα αποθήκευσης.
          </li>
          <li>
            Ασφάλεια κωδικών πρόσβασης: Οι κωδικοί πρόσβασης δεν αποθηκεύονται ποτέ σε απλή μορφή·
            χρησιμοποιούμε ασφαλή, μονόδρομα κρυπτογραφικά hashes με «αλάτι» (bcrypt ή αντίστοιχο).
          </li>
        </ul>
        <h3>15.2 Ασφάλεια πληρωμών</h3>
        <p>
          Η υποδομή πληρωμών της VivianLab έχει σχεδιαστεί έτσι ώστε να μην αποθηκεύει, μεταδίδει ή
          επεξεργάζεται ποτέ ακατέργαστα δεδομένα κατόχων καρτών στους διακομιστές μας. Όλη η
          επεξεργασία πληρωμών ανατίθεται στη Stripe, έναν παγκοσμίως έμπιστο πάροχο πληρωμών,
          πιστοποιημένο ως Πάροχος Υπηρεσιών Επιπέδου 1 (PCI DSS Level 1).
        </p>
        <p>
          Όταν εισάγετε τα στοιχεία πληρωμής σας, οι πληροφορίες αυτές μεταδίδονται απευθείας από το
          πρόγραμμα περιήγησής σας (browser) στους διακομιστές της Stripe μέσω κρυπτογραφημένων
          συνδέσεων TLS, παρακάμπτοντας πλήρως το σύστημα (backend) της VivianLab. Η Stripe
          κρυπτογραφεί τα δεδομένα της κάρτας σας μέσω της μεθόδου tokenization. Η VivianLab αποθηκεύει
          μόνο ένα ψηφιακό διακριτικό (token) και όχι τα πραγματικά στοιχεία της κάρτας σας.
        </p>
        <h3>15.3 Ασφάλεια υποδομής & Πλατφόρμας</h3>
        <p>
          Η Πλατφόρμα μας είναι βασισμένη σε ασφαλή υποδομή αγοράς (όπως το Sharetribe), με
          κρυπτογράφηση κατά τη μεταφορά (TLS 1.2+) και κρυπτογράφηση κατά την αποθήκευση (AES-256). Η
          υποδομή μας φιλοξενείται σε ασφαλείς παρόχους cloud (π.χ. AWS, Azure) που διαθέτουν
          πιστοποιήσεις ISO 27001, SOC 2 και άλλες παρεμφερείς πιστοποιήσεις. Η φυσική ασφάλεια, η
          ασφάλεια δικτύου και η πλεονάζουσα υποδομή (redundancy) διαχειρίζονται από τους εν λόγω
          παρόχους.
        </p>
        <h3>15.4 Οργανωτικά μέτρα</h3>
        <ul>
          <li>Έλεγχος πρόσβασης βάσει ρόλων (RBAC)</li>
          <li>Αρχή της ελάχιστης πρόσβασης</li>
          <li>Καταγραφές ελέγχου και παρακολούθηση</li>
          <li>Επιχειρησιακά περιβάλλοντα περιορισμένης πρόσβασης</li>
          <li>Υποχρεώσεις εμπιστευτικότητας για το προσωπικό και τους εργολάβους</li>
          <li>Τακτική εκπαίδευση σε θέματα ασφάλειας και GDPR</li>
          <li>Σχέδια απόκρισης σε περιστατικά ασφάλειας και επιχειρησιακής συνέχειας</li>
        </ul>
        <h3>15.5 Ασφάλεια προσωπικών δεδομένων – Συνοπτικός πίνακας</h3>
        <p>Ο παρακάτω πίνακας συνοψίζει τις βασικές δικλείδες ασφαλείας:</p>
        <ul>
          <li>
            Διαπιστευτήρια λογαριασμού (όνομα χρήστη, κωδικός πρόσβασης, email): HTTPS/TLS 1.2+,
            AES-256, hashing κωδικών (bcrypt + salt), διαχείριση συνεδριών, προαιρετικό MFA.
          </li>
          <li>
            Προσωπικά δεδομένα ταυτοποίησης (όνομα, επώνυμο, ημερομηνία γέννησης, χώρα, πόλη,
            διεύθυνση, τηλέφωνο): HTTPS/TLS 1.2+, AES-256, RBAC, καταγραφή ελέγχου (audit logging),
            ελαχιστοποίηση δεδομένων.
          </li>
          <li>
            Πληροφορίες πληρωμής (όνομα κατόχου κάρτας, αριθμός κάρτας, CVV, ημερομηνία λήξης,
            διεύθυνση χρέωσης): Απευθείας στη Stripe μέσω TLS, tokenized (δεν αποθηκεύονται
            ακατέργαστα δεδομένα κάρτας), PCI DSS Level 1 (μέσω Stripe), tokenization, 3D Secure,
            εντοπισμός απάτης.
          </li>
          <li>
            Μεταδεδομένα συναλλαγών (ID συναλλαγής, ποσό, ημερομηνία, κατάσταση): HTTPS/TLS 1.2+,
            AES-256, καταγραφές ελέγχου, διατήρηση σύμφωνα με τη φορολογική νομοθεσία.
          </li>
          <li>
            Δεδομένα υγείας (συμπτώματα, στάδιο εμμηνόπαυσης, διάθεση, βιομετρικά στοιχεία από
            wearables, τρόπος ζωής): HTTPS/TLS 1.2+, AES-256, ρητή συγκατάθεση, διαχωρισμένη
            αποθήκευση, ψευδωνυμοποίηση όπου εφαρμόζεται, περιορισμένη διατήρηση, DPIA.
          </li>
          <li>
            Δεδομένα συνεδριών & ραντεβού (ημερομηνίες ραντεβού, όνομα ειδικού, σημειώσεις):
            HTTPS/TLS 1.2+, AES-256, ρόλος εκτελούντος την επεξεργασία για λογαριασμό του Ειδικού,
            RBAC, καταγραφές ελέγχου, ασφαλή κανάλια.
          </li>
          <li>
            Δεδομένα σύνδεσης Google Calendar (συμβάντα, σύνδεσμοι συναντήσεων, μεταδεδομένα):
            HTTPS/TLS 1.2+ (OAuth 2.0), AES-256 (tokens), ρητή συγκατάθεση, περιορισμένο πεδίο
            εφαρμογής, ανάκληση ελεγχόμενη από τον χρήστη, ασφάλεια Google API.
          </li>
          <li>
            Δεδομένα Newsletter & μάρκετινγκ (email, όνομα, αρχεία συγκατάθεσης): HTTPS/TLS 1.2+,
            AES-256, βάσει συγκατάθεσης, σύνδεσμος απεγγραφής, καταγραφές συγκατάθεσης.
          </li>
          <li>
            Cookies & δεδομένα αναλύσεων (IP, ID συσκευής, πληροφορίες προγράμματος περιήγησης,
            πρότυπα χρήσης): HTTPS/TLS 1.2+, AES-256 (όπου αποθηκεύονται),
            ανωνυμοποίηση/ψευδωνυμοποίηση, διαχείριση συγκατάθεσης, όρια διατήρησης.
          </li>
          <li>
            Δεδομένα μέσων κοινωνικής δικτύωσης (όνομα χρήστη, δημόσιο προφίλ, αλληλεπιδράσεις):
            HTTPS/TLS 1.2+, AES-256, μόνο δημόσια δεδομένα, περιορισμένη διατήρηση, κοινή χρήση
            ελεγχόμενη από τον χρήστη.
          </li>
          <li>
            Τεχνικά δεδομένα & δεδομένα συσκευής (διεύθυνση IP, λειτουργικό σύστημα, ID συσκευής,
            γλώσσα, ζώνη ώρας): HTTPS/TLS 1.2+, AES-256, ψευδωνυμοποίηση IP, συγκέντρωση δεδομένων,
            πολιτικές διατήρησης αρχείων καταγραφής, παρακολούθηση ασφάλειας.
          </li>
          <li>
            Δεδομένα αίτησης εργασίας (βιογραφικό σημείωμα, εκπαίδευση, δεξιότητες, εργασιακή
            εμπειρία): HTTPS/TLS 1.2+, AES-256, πρόσβαση περιορισμένη στο HR/διευθυντές προσλήψεων,
            περιορισμένη διατήρηση, ασφαλής διαγραφή.
          </li>
        </ul>
        <h3>15.6 Συνεχής Βελτίωση Ασφάλειας</h3>
        <p>Δεσμευόμαστε για συνεχή βελτίωση μέσω:</p>
        <ul>
          <li>Τακτικών ελέγχων ασφαλείας (security audits)</li>
          <li>Σάρωσης ευπαθειών και δοκιμών διείσδυσης (penetration testing)</li>
          <li>Διαχείρισης ενημερώσεων ασφαλείας (security patch management)</li>
          <li>Παρακολούθησης συμμόρφωσης</li>
          <li>Ασκήσεων απόκρισης σε περιστατικά</li>
          <li>Παρακολούθησης αναδυόμενων απειλών ασφαλείας</li>
        </ul>
        <h3>15.7 Ο ρόλος σας στην ασφάλεια</h3>
        <p>Θα πρέπει να:</p>
        <ul>
          <li>Διατηρείτε τον κωδικό πρόσβασής σας εμπιστευτικό και ισχυρό</li>
          <li>Αποσυνδέεστε μετά τη χρήση σε κοινόχρηστες συσκευές</li>
          <li>Ενεργοποιείτε τον έλεγχο ταυτότητας πολλαπλών παραγόντων (MFA), εφόσον είναι διαθέσιμος</li>
          <li>Παρακολουθείτε τον λογαριασμό σας και να αναφέρετε οποιαδήποτε ύποπτη δραστηριότητα</li>
          <li>Διατηρείτε τις συσκευές και το λογισμικό σας ενημερωμένα</li>
          <li>Είστε προσεκτικοί με απόπειρες ηλεκτρονικού ψαρέματος (phishing)</li>
        </ul>
        <h3>15.8 Διαδικασία Ειδοποίησης Παραβίασης</h3>
        <p>
          Στην περίπτωση παραβίασης προσωπικών δεδομένων που ενδέχεται να θέσει σε κίνδυνο τα
          δικαιώματα και τις ελευθερίες σας, θα ειδοποιήσουμε την αρμόδια εποπτική αρχή εντός 72 ωρών
          και, όπου απαιτείται, θα ενημερώσουμε τα επηρεαζόμενα άτομα χωρίς αδικαιολόγητη καθυστέρηση,
          σύμφωνα με τα Άρθρα 33 και 34 του GDPR.
        </p>
        <p>
          Μπορείτε να αναφέρετε οποιοδήποτε ύποπτο περιστατικό ασφαλείας ή παραβίαση δεδομένων στο
          info@vivianlab.com.
        </p>
        <h3>15.9 Ασφάλεια τρίτων μερών</h3>
        <p>
          Όλοι οι τρίτοι πάροχοι υπηρεσιών και οι εκτελούντες την επεξεργασία με τους οποίους
          μοιραζόμαστε τα δεδομένα σας δεσμεύονται συμβατικά να:
        </p>
        <ul>
          <li>Εφαρμόζουν κατάλληλα τεχνικά και οργανωτικά μέτρα ασφαλείας</li>
          <li>Επεξεργάζονται τα δεδομένα μόνο σύμφωνα με τις καταγεγραμμένες οδηγίες μας</li>
          <li>Τηρούν την εμπιστευτικότητα</li>
          <li>Μας ειδοποιούν για τυχόν παραβιάσεις δεδομένων ή περιστατικά ασφαλείας</li>
          <li>Συμμορφώνονται με τον GDPR και τους ισχύοντες νόμους περί προστασίας δεδομένων</li>
          <li>Υποβάλλονται σε ελέγχους και αξιολογήσεις ασφαλείας όπου απαιτείται</li>
        </ul>
        <h3>15.10 Διαφάνεια Συστήματος AI, Κίνδυνοι και Διασφαλίσεις</h3>
        <p>
          Σύμφωνα με την Πράξη της ΕΕ για την Τεχνητή Νοημοσύνη (EU AI Act), παρέχουμε τις ακόλουθες
          πληροφορίες σχετικά με τα συστήματα ΤΝ μας:
        </p>
        <p>
          Φύση του Συστήματος AI: Οι λειτουργίες AI που διατίθενται στην Πλατφόρμα ταξινομούνται ως
          συστήματα περιορισμένου κινδύνου, σχεδιασμένα για χρήση ενημέρωσης και ευεξίας.
        </p>
        <p>Γνωστοί Περιορισμοί και Κίνδυνοι: Τα αποτελέσματα που παράγονται από την ΤΝ ενδέχεται:</p>
        <ul>
          <li>Να περιέχουν ανακρίβειες ή σφάλματα.</li>
          <li>Να είναι ελλιπή ή παρωχημένα.</li>
          <li>Να μην αντικατοπτρίζουν τις ατομικές συνθήκες υγείας.</li>
          <li>Να επηρεάζονται από τα δεδομένα που παρέχει ο χρήστης.</li>
        </ul>
        <p>
          Ανθρώπινη Εποπτεία: Τα συστήματα ΤΝ μας έχουν σχεδιαστεί με μηχανισμούς ανθρώπινης εποπτείας,
          συμπεριλαμβανομένης της παρακολούθησης περιεχομένου, φίλτρων ασφαλείας και της δυνατότητας
          περιορισμού ή απενεργοποίησης ορισμένων αποτελεσμάτων όπου κρίνεται απαραίτητο.
        </p>
        <p>
          Ευθύνη Χρήστη: Οι χρήστες παραμένουν πλήρως υπεύθυνοι για τον τρόπο με τον οποίο ερμηνεύουν
          και χρησιμοποιούν το περιεχόμενο που παράγεται από την ΤΝ. Ο Βοηθός ΤΝ δεν πρέπει να
          χρησιμοποιείται για ιατρικές, νομικές ή άλλες αποφάσεις υψηλού κινδύνου.
        </p>
        <p>
          Μέτρα Ασφάλειας και Παρακολούθησης ΤΝ: Εφαρμόζουμε πρόσθετες διασφαλίσεις για τα συστήματα
          ΤΝ, συμπεριλαμβανομένης της παρακολούθησης για επιβλαβή ή ακατάλληλα αποτελέσματα, του
          περιορισμού ρυθμού (rate limiting), του φιλτραρίσματος περιεχομένου και της συνεχούς
          αξιολόγησης της απόδοσης και των κινδύνων του συστήματος.
        </p>
      </section>

      {/* 16. Ποια είναι τα δικαιώματά σας; */}
      <section>
        <h2>16. Ποια είναι τα δικαιώματά σας;</h2>
        <p>Σύμφωνα με τον GDPR, έχετε, μεταξύ άλλων, τα ακόλουθα δικαιώματα:</p>
        <ul>
          <li>
            <strong>Δικαίωμα πρόσβασης:</strong>
            <br />
            Να ενημερωθείτε αν επεξεργαζόμαστε τα Δεδομένα σας και να λάβετε αντίγραφο αυτών, καθώς
            και πληροφορίες για σκοπούς, κατηγορίες, αποδέκτες, χρόνο διατήρησης, δικαιώματά σας,
            ύπαρξη αυτοματοποιημένης λήψης αποφάσεων κ.λπ.
          </li>
          <li>
            <strong>Δικαίωμα διόρθωσης:</strong>
            <br />
            Να ζητήσετε τη διόρθωση ανακριβών ή ελλιπών δεδομένων (π.χ. διόρθωση ονόματος ή
            ενημέρωση διεύθυνσης).
          </li>
          <li>
            <strong>Δικαίωμα διαγραφής («δικαίωμα στη λήθη»):</strong>
            <br />
            Να ζητήσετε τη διαγραφή των δεδομένων σας, εφόσον δεν είναι πλέον απαραίτητα ή εάν
            ανακαλείτε τη συγκατάθεσή σας (όταν αυτή είναι η μοναδική νομική βάση).
          </li>
          <li>
            <strong>Δικαίωμα φορητότητας:</strong>
            <br />
            Να λάβετε τα δεδομένα που μας έχετε παράσχει σε δομημένο, κοινώς χρησιμοποιούμενο και
            αναγνώσιμο από μηχανή μορφότυπο ή να ζητήσετε τη διαβίβασή τους σε άλλον Υπεύθυνο
            Επεξεργασίας.
          </li>
          <li>
            <strong>Δικαίωμα περιορισμού επεξεργασίας:</strong>
            <br />
            Να ζητήσετε τον περιορισμό της επεξεργασίας ενόσω εξετάζονται αντιρρήσεις σας ή
            αμφισβητείτε την ακρίβεια των δεδομένων.
          </li>
          <li>
            <strong>Δικαίωμα εναντίωσης και ανάκλησης συναίνεσης:</strong>
            <br />
            Να εναντιωθείτε στην επεξεργασία των Δεδομένων σας, όταν αυτή βασίζεται σε έννομο
            συμφέρον.
            <br />
            Να ανακαλέσετε οποτεδήποτε τη συγκατάθεση που έχετε παράσχει, με ισχύ για το μέλλον,
            ιδίως για σκοπούς marketing ή επεξεργασία ειδικών κατηγοριών δεδομένων.
          </li>
        </ul>
        <h3>Δικαιώματα Σχετικά με την Επεξεργασία ΤΝ</h3>
        <p>Έχετε το δικαίωμα:</p>
        <ul>
          <li>Να ενημερώνεστε όταν αλληλεπιδράτε με ΤΝ.</li>
          <li>Να ζητάτε ανθρώπινη παρέμβαση, όπου αυτό είναι εφικτό.</li>
          <li>
            Να αντιταχθείτε στην επεξεργασία που περιλαμβάνει ΤΝ, όταν αυτή σας επηρεάζει
            σημαντικά.
          </li>
          <li>
            Να ανακαλέσετε τη συγκατάθεσή σας για την επεξεργασία δεδομένων που σχετίζονται με την ΤΝ
            ανά πάσα στιγμή.
          </li>
        </ul>
        <h3>Πρόσθετα Δικαιώματα για Χρήστες εκτός ΕΟΧ (Συμπεριλαμβανομένων των Ηνωμένων Πολιτειών)</h3>
        <p>
          Ανάλογα με την τοποθεσία σας, ενδέχεται να έχετε πρόσθετα δικαιώματα βάσει της ισχύουσας
          νομοθεσίας, συμπεριλαμβανομένων:
        </p>
        <ul>
          <li>
            Του δικαιώματος να γνωρίζετε ποια προσωπικά δεδομένα συλλέγουμε και πώς χρησιμοποιούνται.
          </li>
          <li>Του δικαιώματος να ζητήσετε τη διαγραφή των προσωπικών σας δεδομένων.</li>
          <li>
            Του δικαιώματος εξαίρεσης (opt-out) από την πώληση ή την κοινοποίηση προσωπικών δεδομένων
            (δεν πωλούμε προσωπικά δεδομένα).
          </li>
          <li>Του δικαιώματος στη μη διάκριση λόγω άσκησης των δικαιωμάτων σας.</li>
        </ul>
        <p>
          Οι κάτοικοι ορισμένων πολιτειών των ΗΠΑ (όπως η Καλιφόρνια, η Βιρτζίνια, το Κολοράντο και
          άλλες) μπορούν να ασκήσουν αυτά τα δικαιώματα επικοινωνώντας μαζί μας στο info@vivianlab.com.
        </p>
        <p>
          <strong>Επιλογή μη λήψης Επικοινωνιών Μάρκετινγκ.</strong> Μπορείτε να επιλέξετε να μη λαμβάνετε επικοινωνίες μάρκετινγκ αλλάζοντας τις ρυθμίσεις εγγραφής σας για email και SMS, κάνοντας κλικ στον σύνδεσμο απεγγραφής (unsubscribe) ή ακολουθώντας τις οδηγίες που περιέχονται στο μήνυμα, ή επικοινωνώντας μαζί μας. 
        </p>
      </section>

      {/* 17. Πώς μπορείτε να ασκήσετε τα δικαιώματά σας; */}
      <section>
        <h2>17. Πώς μπορείτε να ασκήσετε τα δικαιώματά σας;</h2>
        <p>
          Μπορείτε να υποβάλετε σχετικό αίτημα στο email: info@vivianlab.com με θέμα «Άσκηση
          Δικαιώματος» και θα το εξετάσουμε το συντομότερο δυνατόν.
        </p>
        <p>Ειδικά:</p>
        <ul>
          <li>
            Για διόρθωση δεδομένων στον λογαριασμό χρήστη, μπορείτε να συνδεθείτε και να τα αλλάξετε
            απευθείας.
          </li>
          <li>
            Για ανάκληση συγκατάθεσης στο newsletter, ακολουθείτε τον σύνδεσμο διαγραφής στο τέλος
            κάθε email.
          </li>
          <li>
            Για απενεργοποίηση web push notifications, μπορείτε να το κάνετε από τις ρυθμίσεις του
            browser σας.
          </li>
        </ul>
        <p>
          <strong>Έλεγχος ταυτότητας:</strong>
          <br />
          Προς προστασία της εμπιστευτικότητας, μπορεί να ζητήσουμε επιβεβαίωση ταυτότητας πριν
          ικανοποιήσουμε το αίτημά σας. Αν τρίτο πρόσωπο ενεργεί εξ ονόματός σας, θα ζητήσουμε
          αποδεικτικά εξουσιοδότησης.
        </p>
      </section>

      {/* 18. Πότε απαντάμε στα αιτήματά σας; */}
      <section>
        <h2>18. Πότε απαντάμε στα αιτήματά σας;</h2>
        <p>
          Απαντάμε δωρεάν και χωρίς αδικαιολόγητη καθυστέρηση, το αργότερο εντός ενός (1) μήνα από
          την παραλαβή.
        </p>
        <p>
          Αν το αίτημα είναι πολύπλοκο ή υπάρχουν πολλά αιτήματα, ο χρόνος μπορεί να παραταθεί κατά
          δύο (2) επιπλέον μήνες, για τους οποίους θα ενημερωθείτε εντός του πρώτου μήνα.
        </p>
      </section>

      {/* 19. Ποιο είναι το εφαρμοστέο δίκαιο; */}
      <section>
        <h2>19. Ποιο είναι το εφαρμοστέο δίκαιο;</h2>
        <p>
          Εφαρμοστέο δίκαιο είναι το Ελληνικό Δίκαιο, όπως έχει διαμορφωθεί με τον GDPR και το εν
          γένει ισχύον εθνικό και ευρωπαϊκό πλαίσιο προστασίας δεδομένων.
        </p>
        <p>
          Κάθε διαφορά που προκύπτει σε σχέση με την προστασία των προσωπικών σας δεδομένων
          υπόκειται σε διαδικασία διαμεσολάβησης σύμφωνα με τον Κανονισμό Διαμεσολάβησης του
          αρμοδίου φορέα.
        </p>
        <p>
          Εφόσον η διαφορά δεν επιλυθεί, επιλύεται αποκλειστικά και τελεσίδικα από διαιτητικό
          δικαστήριο ή/και τα καθ’ ύλην αρμόδια Δικαστήρια Αθηνών, όπως ορίζεται στους σχετικούς
          όρους.
        </p>
      </section>

      {/* 20. Πού μπορείτε να απευθυνθείτε αν θεωρείτε ότι παραβιάζουμε την ισχύουσα νομοθεσία; */}
      <section>
        <h2>
          20. Πού μπορείτε να απευθυνθείτε αν θεωρείτε ότι παραβιάζουμε την ισχύουσα νομοθεσία;
        </h2>
        <p>
          Έχετε δικαίωμα να υποβάλετε καταγγελία στην Αρχή Προστασίας Δεδομένων Προσωπικού Χαρακτήρα
          (Λ. Κηφισίας 1-3, 115 23, Αθήνα, τηλ. 210 6475600, email: contact@dpa.gr), εφόσον θεωρείτε
          ότι η επεξεργασία των Δεδομένων σας παραβιάζει το ισχύον εθνικό και ευρωπαϊκό πλαίσιο
          προστασίας προσωπικών δεδομένων.
        </p>
      </section>

      {/* 21. Πώς θα ενημερωθείτε για τυχόν αλλαγές στην Πολιτική αυτή; */}
      <section>
        <h2>21. Πώς θα ενημερωθείτε για τυχόν αλλαγές στην Πολιτική αυτή;</h2>
        <p>Ενημερώνουμε την παρούσα Πολιτική Απορρήτου όποτε είναι αναγκαίο.</p>
        <p>
          Αν υπάρξουν σημαντικές αλλαγές ή αλλαγές στον τρόπο που χρησιμοποιούμε τα Δεδομένα σας, θα
          αναρτήσουμε σχετική ενημέρωση στον ιστότοπό μας πριν οι αλλαγές τεθούν σε ισχύ και θα σας
          ενημερώσουμε, όπου απαιτείται.
        </p>
        <p>
          Σας ενθαρρύνουμε να ελέγχετε περιοδικά την Πολιτική, ώστε να γνωρίζετε πώς προστατεύονται
          τα Δεδομένα σας.
        </p>
        <p>Η παρούσα Πολιτική Απορρήτου τροποποιήθηκε τελευταία φορά την 16/11/2023.</p>
        <p>
          Για οποιαδήποτε περαιτέρω πληροφορία ή απορία σχετικά με την Πολιτική Απορρήτου, μπορείτε
          να επικοινωνήσετε με την Εταιρεία στο info@vivianlab.com.
        </p>
      </section>
    </div>
  );
}

export default PrivacyGreek;
